export default __webpack_public_path__ + "static/media/link-icon.703d5c19.svg";